import React from 'react'

const ProductDescription = ({ description, style, className = '' }) => {
  return (
    <div className={`cover-deskripsi ${className}`.trim()} style={style}>
      <h2>Deskripsi</h2>
      <p className="text">{description}</p>
    </div>
  )
}

export default ProductDescription
